import { baseApi } from "./baseAPI"

export const brandsAPI = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getMeasurementUnits: build.query<string[], void>({
            query: () => "MeasurementUnit",
            // Cache for id
            providesTags: (_result, _error, brand) => [{ type: 'MeasurementUnitDescriptions', value: 'ALL'}],
            // transformResponse: (rawResult: Promotion, meta) => fixDates(rawResult)
        })
    }),
    overrideExisting: false,
})

export const {
    useGetMeasurementUnitsQuery
} = brandsAPI
